import React from "react";
import "./products.css";

import Card from "../components/Card";
import Recommended from "../recommended/Recommended";

export default function Products({ handleClick, datas }) {
  return (
    <div className="list-data">
      <Recommended handleClick={handleClick} />
      <div className="product-list">
        {datas.map((data, i) => (
          <Card key={i} data={data} />
        ))}
      </div>
    </div>
  );
}
